import React,{useCallback,useEffect,useState}from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faUsers, faClock, faPlay, 
  faCheckCircle, faDatabase, faServer, 
  faCloud, faCode, faProjectDiagram,
  faLaptopCode, faCertificate, faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';

const Azure = () => {
    const [showModal, setShowModal] = useState(false);
      const [formCourseName, setFormCourseName] = useState('Azure');
      const [formData, setFormData] = useState({
        fullName: '',
        mobileNumber: '',
        email: '',
      });
    
      const openModal = () => setShowModal(true);
      const closeModal = useCallback(() => {
        setShowModal(false);
        setFormData({ fullName: '', mobileNumber: '', email: '' });
      }, []);
    
      useEffect(() => {
        const handleEsc = (e) => {
          if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
      }, [closeModal]);
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileNumber') {
          const digitsOnly = value.replace(/\D/g, '');
          if (digitsOnly.length <= 10) {
            setFormData(prev => ({ ...prev, [name]: digitsOnly }));
          }
        } else {
          setFormData(prev => ({ ...prev, [name]: value }));
        }
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const { fullName, mobileNumber, email } = formData;
    
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
          alert('Please fill in valid details.');
          return;
        }
    
        try {
          const response = await fetch('https://api.dikshasea.in/api/enrollments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formData, course: formCourseName }),
          });
    
          const result = await response.json();
          if (response.ok) {
            alert('Enrollment successful!');
            closeModal();
          } else {
            alert(result.message || 'Submission failed');
          }
        } catch (err) {
          console.error(err);
          alert('Error submitting form');
        }
      };
    
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New Azure Certification</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">Microsoft Azure</span>
              </h1>
              <p className="hero-subtitle">
                Become an Azure cloud expert with our comprehensive certification program. 
                Gain hands-on experience with Azure services, architectures, and best practices 
                to design, deploy, and manage enterprise cloud solutions.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.7/5.0</div>
                    <small className="text-muted">(4,800 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">22,000+</div>
                    <small className="text-muted">Certified Professionals</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">85 hours</div>
                    <small className="text-muted">Hands-on Labs</small>
                  </div>
                </div>
              </div>
              
             <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="subcourses-images/azure.jpg" 
                  alt="Azure Certification Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="course-details">
          <div className="course-content">
            {/* About Course */}
            <section className="about-course">
              <h2 className="section-title">About This Certification</h2>
              <p>This comprehensive Azure certification program prepares you for cloud architect and developer roles. You'll gain expertise in core Azure services, security best practices, and cloud solution design patterns used by enterprises worldwide.</p>
              <p>Through real-world scenarios and hands-on labs, you'll build the skills needed to pass Microsoft Azure certifications and implement professional cloud solutions.</p>
            </section>
            
            {/* Curriculum */}
            <section className="curriculum">
              <h2 className="section-title">Certification Path</h2>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 1: Azure Fundamentals</h3>
                <p>Master core Azure services and cloud concepts</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Global Infrastructure</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Active Directory</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Virtual Machines & Compute</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Blob Storage & Data Services</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 2: Networking & Security</h3>
                <p>Design secure, scalable cloud networks</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Virtual Networks (VNet)</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Load Balancers & Traffic Manager</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Network Security Groups</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Firewall & DDoS Protection</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 3: Databases & Analytics</h3>
                <p>Implement data solutions on Azure</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure SQL Database</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cosmos DB</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Synapse Analytics</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data Factory</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 4: Deployment & Automation</h3>
                <p>Master CI/CD and infrastructure as code</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure App Service</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> ARM Templates</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure DevOps Pipelines</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Terraform on Azure</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Advanced Architectures</h3>
                <p>Design enterprise-grade cloud solutions</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Kubernetes Service</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Microservices on Azure</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Multi-region Deployments</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Well-Architected Framework</div>
                </div>
              </div>
            </section>
          </div>  
          
          <div className="course-sidebar">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="info-content">
                <h4>Duration</h4>
                <p>3 Months (15-20 hrs/week)</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faCertificate} />
              </div>
              <div className="info-content">
                <h4>Certifications</h4>
                <p>Azure Administrator</p>
                <p>Azure Solutions Architect</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faLaptopCode} />
              </div>
              <div className="info-content">
                <h4>Hands-on Labs</h4>
                <p>50+ Real-world Exercises</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="info-content">
                <h4>Prerequisites</h4>
                <p>Basic Networking Knowledge</p>
                <p>Windows/Linux Fundamentals</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>
              <div className="info-content">
                <h4>Career Support</h4>
                <p>Resume Preparation</p>
                <p>Interview Coaching</p>
              </div>
            </div>
            
            <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Azure</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Azure;